/**
 * Dev-only logging helpers.
 *
 * Production builds stay silent: debugging output must never leak internal
 * details (API shapes, error traces) to end users' consoles. Use these
 * instead of console.* anywhere outside of build scripts.
 */
const isDev = process.env.NODE_ENV === "development";

export const devError = (...args) => {
  if (isDev) console.error(...args);
};

export const devWarn = (...args) => {
  if (isDev) console.warn(...args);
};
